import { Component } from '@theme/component';

/**
 * A "Quick Shop" text-link trigger that puppet-clicks the theme's real,
 * hidden quick-add engine (`<quick-add-component>`) nested inside it —
 * whichever of its two buttons ("Add" or "Choose options") is currently
 * active, per its `data-quick-add-button` attribute. Mirrors the puppet-click
 * pattern `sticky-add-to-cart.js` uses for the same reason: reuse the real
 * add-to-cart/modal logic untouched, only the visible trigger is custom.
 *
 * @extends {Component}
 */
class ProductQuickShop extends Component {
  /**
   * Forwards the click to the real quick-add button.
   */
  handleClick = () => {
    const engine = this.querySelector('quick-add-component');
    if (!(engine instanceof HTMLElement)) return;

    const target =
      engine.dataset.quickAddButton === 'add'
        ? engine.querySelector('.quick-add__button--add')
        : engine.querySelector('.quick-add__button--choose');

    if (target instanceof HTMLElement) target.click();
  };
}

if (!customElements.get('product-quick-shop')) {
  customElements.define('product-quick-shop', ProductQuickShop);
}
